import apiClient from "./index";
import { ApiError } from "../types/error";
import { isAxiosError } from "axios";
import { ApiResponse } from "./auth";
import { handleApiError } from "../utils/utils";
import { LocationSettings, SettingsResponse } from "../types";

export interface DeliverySlot {
  id: string;
  dayOfWeek:
    | "MONDAY"
    | "TUESDAY"
    | "WEDNESDAY"
    | "THURSDAY"
    | "FRIDAY"
    | "SATURDAY"
    | "SUNDAY";
  pickupSchedule: {
    startTime: string;
    endTime: string;
  };
  deliverySchedule: {
    startTime: string;
    endTime: string;
  };
  isActive: boolean;
}

export interface DeliverySettings {
  id: string;
  pricePerKm: number;
  maxDeliveryDistanceKm: number;
  minOrderAmountFreeDelivery: number;
  deliverySlots: DeliverySlot[];
  createdAt: string;
  updatedAt: string;
}

export const getDeliverySettings = async (): Promise<
  ApiResponse<DeliverySettings>
> => {
  try {
    const response = await apiClient.get<DeliverySettings>(
      "/settings/delivery"
    );
    return { data: response.data, error: null };
  } catch (error) {
    return handleApiError(
      error,
      "An unknown error occurred during fetching delivery settings."
    );
  }
};

export const getLocationSettings = async (): Promise<
  ApiResponse<LocationSettings>
> => {
  try {
    const response = await apiClient.get<LocationSettings>(
      "/settings/location"
    );
    return { data: response.data, error: null };
  } catch (error) {
    return handleApiError(
      error,
      "An unknown error occurred during fetching location settings."
    );
  }
};
